import { render, staticRenderFns } from "./LinkFacility.vue?vue&type=template&id=09bce0af&"
import script from "./LinkFacility.vue?vue&type=script&lang=js&"
export * from "./LinkFacility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports